'use client';

import { useSession } from 'next-auth/react';
import { useEffect, useRef } from 'react';
import toast from 'react-hot-toast';

const toastStyle = {
  background: '#112240',
  color: '#fff',
  border: '1px solid #64ffda',
};

export function AuthNotifier() {
  const { data: session, status } = useSession();
  const welcomeShown = useRef(false);

  useEffect(() => {
    if (status === 'loading') return;

    // Alerte de connexion : déclenché par le flag posé dans la page signin
    if (
      status === 'authenticated' &&
      session?.user &&
      !welcomeShown.current &&
      typeof window !== 'undefined' &&
      sessionStorage.getItem('justLoggedIn') === '1'
    ) {
      sessionStorage.removeItem('justLoggedIn');
      welcomeShown.current = true;
      const name = session.user.name || session.user.email || 'utilisateur';
      toast.success(`Bienvenue, ${name} ! Vous êtes connecté.`, {
        duration: 4000,
        style: toastStyle,
        iconTheme: { primary: '#64ffda', secondary: '#0a192f' },
      });
    }

    // Alerte de déconnexion : flag posé avant signOut
    if (
      typeof window !== 'undefined' &&
      sessionStorage.getItem('justLoggedOut') === '1'
    ) {
      sessionStorage.removeItem('justLoggedOut');
      toast.success('Vous avez été déconnecté avec succès.', {
        duration: 3000,
        style: toastStyle,
        iconTheme: { primary: '#64ffda', secondary: '#0a192f' },
      });
    }
  }, [status, session]);

  return null;
}
